const lazyVideos = Array.from(document.querySelectorAll("video.lazy-video"));

function playLazyVideo(video) {
    video.muted = true;
    const p = video.play();
    if (p && p.catch) {
        p.catch((err) => {
            /* Autoplay can be refused for reasons that later go away — Safari/iOS rejects until the
               media is ready or (in Low Power Mode) until the user interacts. Flag it and retry
               rather than giving up, which is what the retry handlers below key off. */
            video.dataset.autoplayBlocked = "1";
            console.warn("Video autoplay failed:", err);
        });
    }
}

if ("IntersectionObserver" in window) {
    const lazyVideoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            const video = entry.target;
            if (!video) return;

            if (entry.isIntersecting) {
                if (video.dataset.poster) {
                    video.poster = video.dataset.poster;
                }

                /* Swap the sources once. Re-running load() on every re-entry would restart the
                   clip and re-download it. */
                if (!video.dataset.lazyLoaded) {
                    const sources = video.querySelectorAll("source");
                    if (!sources.length) return;

                    sources.forEach((source) => {
                        if (source.dataset.src) {
                            source.src = source.dataset.src;
                        }
                    });

                    video.load();
                    video.dataset.lazyLoaded = "1";
                    video.classList.remove("lazy-video");
                }

                playLazyVideo(video);
            } else if (!video.paused) {
                video.pause();
            }
        });
    });

    /* Deliberately NOT unobserved after the first attempt: a rejected play() has to stay
       retryable, and staying observed is also what keeps the pause-when-offscreen branch
       above alive for the rest of the session. */
    lazyVideos.forEach((lazyVideo) => {
        lazyVideoObserver.observe(lazyVideo);
    });

    const retryBlocked = () => {
        document.querySelectorAll('video[data-autoplay-blocked="1"]').forEach((video) => {
            const r = video.getBoundingClientRect();
            const inView = r.bottom > 0 && r.top < window.innerHeight && r.width > 0;
            if (!inView) return;
            delete video.dataset.autoplayBlocked;
            playLazyVideo(video);
        });
    };

    /* A user gesture clears the autoplay block on iOS Low Power Mode and on desktop browsers
       that hold playback until the page has been interacted with. */
    ["click", "touchstart", "keydown"].forEach((evt) => {
        document.addEventListener(evt, retryBlocked, { passive: true });
    });
    document.addEventListener("visibilitychange", () => {
        if (!document.hidden) retryBlocked();
    });
}
